// Configuration from environment variables
// Set these in Cloudflare Pages environment settings

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "https://kyubot.com";

export const SLACK_OAUTH_URL = `${API_BASE_URL}/slack/oauth/start`;
export const SLACK_OAUTH_URL_TRIAL = `${API_BASE_URL}/slack/oauth/start?trial=1`;
